import { render } from "./DisplayElementOrderBonusCartContent.vue?vue&type=template&id=548cd63c&ts=true"
import script from "./DisplayElementOrderBonusCartContent.vue?vue&type=script&lang=ts"
export * from "./DisplayElementOrderBonusCartContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__